module.exports = __webpack_public_path__ + "static/media/biaozhu.012f71fa.png";